<template>
  <div class="blue-grey lighten-5" fluid style="max-width: 100vw">
    <v-responsive height="1100px">
      <v-row cols="12" justify="center">
        <p class="head">よくある質問</p>
      </v-row>
      <v-row cols="12" justify="center">
        <p class="sub">Q&A</p>
      </v-row>

      <transition name="slide-fade">
        <v-row id="qa1" justify="center" class="mt-4" v-show="visible1">
          <div class="question_icon">
            <img src="../assets/question.svg" width="80px" />
          </div>
          <div class="question">
            <p>健保独自の申請書を使用していますが、これも掲載してもらえますか？</p>
          </div>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="qa1" justify="center" v-show="visible1">
          <div class="answer">
            <p>もちろん掲載可能です。
              <br>紙でしかご用意のない申請書については１枚5,000円でデータ化も可能です。
            </p>
          </div>
          <div class="answer_icon">
            <img src="../assets/answer.svg" width="80px" />
          </div>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="qa2" justify="center" class="mt-4" v-show="visible2">
          <div class="question_icon">
            <img src="../assets/question.svg" width="80px" />
          </div>
          <div class="question">
            <p>現在使用中のホームページからの移行もできますか？</p>
          </div>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="qa2" justify="center" v-show="visible2">
          <div class="answer">
            <p>はい、もちろんです！
              <br>取得済みのドメインも引き続き利用できますのでご安心ください。
            </p>
          </div>
          <div class="answer_icon">
            <img src="../assets/answer.svg" width="80px" />
          </div>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="qa3" justify="center" class="mt-4" v-show="visible3">
          <div class="question_icon">
            <img src="../assets/question.svg" width="80px" />
          </div>
          <div class="question">
            <p>組合会で実績報告するための資料ももらえますか？</p>
          </div>
        </v-row>
      </transition>

      <transition name="slide-fade">
        <v-row id="qa3" justify="center" v-show="visible3">
          <div class="answer">
            <p>
              ご希望があれば、アクセス解析レポートを年に１回お作りすることも可能です！（有償）
            </p>
          </div>
          <div class="answer_icon">
            <img src="../assets/answer.svg" width="80px" />
          </div>
        </v-row>
      </transition>
    </v-responsive>
  </div>
</template>

<script>
export default {
  name: "Flow",

  data: () => ({
    visible1: false,
    visible2: false,
    visible3: false,
    visible4: false,
    visible5: false,
    visible6: false,
  }),
  mounted() {
    window.addEventListener("scroll", this.handleScroll);
  },
  methods: {
    handleScroll() {
      var qa1_el = document.getElementById("qa1");
      var top1 = qa1_el.getBoundingClientRect().top;
      this.visible1 = top1 < window.innerHeight + 250;

      var qa2_el = document.getElementById("qa2");
      var top2 = qa2_el.getBoundingClientRect().top;
      this.visible2 = top2 < window.innerHeight + 250;

      var qa3_el = document.getElementById("qa3");
      var top3 = qa3_el.getBoundingClientRect().top;
      this.visible3 = top3 < window.innerHeight + 250;
    },
  },
};
</script>

<style scoped>
.head {
  position: relative;
  font-size: 30px;
  letter-spacing: 0.1em;
}

.head:before {
  content: "";
  position: absolute;
  bottom: -10px;
  display: inline-block;
  width: 350px;
  height: 1px;
  left: 50%;
  -webkit-transform: translateX(-50%);
  transform: translateX(-50%);
  background-color: black;
  border-radius: 2px;
}
.sub {
  color: #808080;
  font-size: 18px;
  letter-spacing: 0.1em;
}
.text {
  margin-top: 20px;
  font-size: 28px;
  letter-spacing: 0.1em;
}
.text2 {
  margin-top: 10px;
  font-size: 18px;
  letter-spacing: 0.1em;
}
.question {
  position: relative;
  display: inline-block;
  margin: 1em 4.5em 1.5em 15px;
  padding: 30px 20px;
  width: 450px;
  font-size: 18px;
  background: #ffffff;
  border-radius: 15px;
}
.question:before {
  content: "";
  position: absolute;
  top: 50%;
  left: -30px;
  margin-top: -15px;
  border: 15px solid transparent;
  border-right: 15px solid #ffffff;
}
.question p {
  margin: 0;
  padding: 0;
}
.question_icon {
  position: relative;
  width: 60px;
  top: 20px;
  right: 50px;
}

.answer {
  position: relative;
  display: inline-block;
  margin: 0em -2em 1.5em 15px;
  padding: 30px 20px;
  width: 450px;
  font-size: 18px;
  background: #ffffff;
  border-radius: 15px;
}
.answer:before {
  content: "";
  position: absolute;
  top: 50%;
  left: 100%;
  margin-top: -15px;
  border: 15px solid transparent;
  border-left: 15px solid #ffffff;
}
.answer p {
  margin: 0;
  padding: 0;
}
.answer_icon {
  position: relative;
  width: 60px;
  top: 10px;
  right: -80px;
}
.slide-fade-enter-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-leave-active {
  transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
}
.slide-fade-enter,
.slide-fade-leave-to {
  transform: translateY(500px);
  opacity: 0;
}
</style>
